<div class="lobbyContainer" appSameHeight className="sameHeight" *ngIf="showlobby" [ngClass]="{'macOS':isMac,'otherOS':!isMac,'hideLobby':!showlobby}" >
    <app-active-drafts2 *ngIf="!isMobile" style="margin-bottom:5px;"></app-active-drafts2>
    <div class="outerDepostLayout" *ngIf="this.noDeposit && this.depositContent">
        <div class="firstDeposit mB5">
          <span class="depositText"><div [innerHTML]="depositContent"></div><a *ngIf="user.payment_verified == 'N' && user.verify_before_deposits" class="link" href="javascript:;" (click)="makePayment()">&nbsp;Verify Your Account.</a></span>
             <button  *ngIf="user.payment_verified == 'Y' || !user.verify_before_deposits" mat-raised-button color="primary" class="mT10 mB10" (click)="makePayment()">Deposit now!</button>
        </div>
    </div>
    <div class="leftSide" [ngClass]="{'sameHeight':!isMobile}">
        <!-- quick links bar -->
        <!--div class="quickCont" *ngIf="!isMobile">
            <div class="quickLinks">
                <a [href]="siteURL+'/create-contest'"><i class="fas fa-trophy"></i> Create a Contest</a>
                <a [href]="siteURL+'/user/refer-friend'"><i class="fas fa-heart"></i> Refer a Friend</a>
                <a [href]="siteURL+'/rules'" class="no-border"><i class="fas fa-clipboard-list"></i> Rules and
                    Scoring</a>
            </div>
            <div class="quickLinks" *ngIf="!isMobile">
                <ng-container *ngIf="draftedToday != null">
                    <div class="quickSection" [ngClass]="{'no-border':nextSlateGame == null || nextSlateClock == null}">
                        <i class="fas fa-bullseye draftedToday"></i>Drafted Today:
                        {{draftedToday}}
                    </div>
                </ng-container>
                <ng-container *ngIf="nextSlateGame != null && nextSlateClock != null">
                    <div class="upcomingSport"
                        [ngStyle]="{'backgroundImage':'url(\''+bucketURL+nextSlateGame+'_icon.svg\')'}"></div>
                    {{nextSlateClock}}
                </ng-container>
            </div>
        </div-->
        <app-game-selector></app-game-selector>
        <ul class="leagueTable" *ngIf="!isMobile" [ngClass]="{'fullwidth':!this.feedChild?.fullWidthLobby}">
            <!--div class="leagueTableHeader" 
                        [ngStyle]="{'width':lobbyScrolling(lobbyTable) ? 'calc(100% - '+scrollBarWidth+'px)' : '100%'}"-->
            <div class="leagueTableHeader">
                <div style="width: 2%;">
                </div>
                <div class="header" (click)="sortTable('name',0)" style="width:40%;text-align:left">
                    <p class="leagueTableHeaderTh" [ngClass]="{'active':tableSort == 'name'}">
                        Contest <i
                        *ngIf="tableSort == 'name'"
                        [ngClass]="{'fas':true,'fa-caret-up':sortDirection == 'asc','fa-caret-down':sortDirection=='desc'}"></i>
                    </p>
                </div>
                <div class="header w-15" (click)="sortTable('draft_type',0)">
                    <p class="leagueTableHeaderTh" [ngClass]="{'active':tableSort == 'draft_type'}">
                        Game Type <i *ngIf="tableSort == 'draft_type'"
                        [ngClass]="{'fas':true,'fa-caret-up':sortDirection == 'asc','fa-caret-down':sortDirection=='desc'}"></i>
                        </p>
                </div>
                <div class="header" (click)="sortTable('buy_in_amount',2)">
                    <p class="leagueTableHeaderTh" [ngClass]="{'active':tableSort == 'buy_in_amount'}">
                        Entry Fee <i
                    *ngIf="tableSort == 'buy_in_amount'"
                    [ngClass]="{'fas':true,'fa-caret-up':sortDirection == 'asc','fa-caret-down':sortDirection=='desc'}"></i>
                    </p>
                </div>
                <div class="header" (click)="sortTable('payout_amount',2)">
                    <p class="leagueTableHeaderTh" [ngClass]="{'active':tableSort == 'payout_amount'}">
                        Total Prizes <i
                    *ngIf="tableSort == 'payout_amount'"
                    [ngClass]="{'fas':true,'fa-caret-up':sortDirection == 'asc','fa-caret-down':sortDirection=='desc'}"></i>
                    </p>
                </div>
                <div class="header" (click)="sortTable('entrants',1)">
                    <p class="leagueTableHeaderTh" [ngClass]="{'active':tableSort == 'entrants'}">
                        Entries <i *ngIf="tableSort == 'entrants'"
                    [ngClass]="{'fas':true,'fa-caret-up':sortDirection == 'asc','fa-caret-down':sortDirection=='desc'}"></i>
                    </p>
                </div>
                <div class="header" (click)="sortTable('draft_time',1)"> 
                    <p class="leagueTableHeaderTh" [ngClass]="{'active':tableSort == 'draft_time'}">
                        &nbsp;Live <i
                        *ngIf="tableSort == 'draft_time'"
                        [ngClass]="{'fas':true,'fa-caret-up':sortDirection == 'asc','fa-caret-down':sortDirection=='desc'}"></i>
                        </p>
                </div>
            </div>
            <mat-progress-bar mode="buffer" *ngIf="!leagues.length && !emptyLobby"></mat-progress-bar>
            <div class="scrollTable" id="style-3" (scroll)="lobbyScroll($event)" #lobbyTable>
                <div class="emptyLobby" *ngIf="emptyLobby">
                    {{ (curGame=='all')?'No contests available right now.':'No '+curGameAbbr.toUpperCase()+' contests are available at this time. Please check again at a later time' }}
                </div>

                <li class="leagueEntry"
                    (click)="openLeague(league.id,league.tournament_id,(league.draft_size - league.league_joined_entrants))"
                    *ngFor="let league of leagues;let i=index;trackBy: trackLeague;">
                    <ng-container *ngIf="lRowVisible(i, lobbyTable)">
                        <div [ngClass]="{entry:true,user_joined:(league.league_member != null && league.league_member == user.id && (league.league_joined_entrants > 0 || league.tournament_id == 0))}">
                            <div class="leagueSport"
                                [ngStyle]="{'backgroundImage':'url(\''+bucketURL+league.league_type.toLowerCase()+'_icon'+darkMode_ext+'.svg?v=1\')'}">
                            </div>
                            <div class="leagueName"
                                [ngStyle]="{'font-weight':((league.lg_bold=='Y')?'bold':'normal')}">
                                {{league.name}}</div>
                            <div class="leagueType td w-15">
                                {{(league.drafttype_id == 5) ? 'Classic Tiers' : (league.drafttype_id == 4) ? 'Rank\'EM' : (league.duration_id == 5 ||
                                league.duration_id == 6) ? 'Playoffs Snake' : (league.duration_id == 8) ? 'Best Ball' : 'Snake Draft'}}
                            </div>
                            <div class="leagueBuyin td">
                                {{(league.buy_in_amount == 0) ? 'FREE' : '$' + (league.buy_in_amount | number:'1.2-2' | Price)}}
                            </div>
                            <div class="leaguePrizes td">${{(league.payout_amount | number:'1.2-2' | Price)}}</div>
                            <div class="leagueEntrants td">
                                <span *ngIf="league.hide_entrant == undefined || league.hide_entrant == 'N'">{{ league.joined_entrants | number:'1.0-0' }}/{{ league.entrants | number:'1.0-0' }}</span>
                                <span *ngIf="league.hide_entrant !== undefined && league.hide_entrant == 'Y'">{{ league.joined_entrants | number:'1.0-0' }}</span>
                            </div>
                            <div class="leagueSchedule td w-10">
                                <span>
                                    {{(leagueLockCounter[league.draft_time]) ? leagueLockCounter[league.draft_time] : getSchedule(league.duration_id,league.earliest_game_schedule,league.last_game_schedule,league.week_no,league.game_id,league.tournament_id)}}
                                </span>
                                <img *ngIf="league?.ticket_id>0" src="assets/images/ticket.png">
                            </div>
                            <div class="entrantsContainer" *ngIf="league.tournament_id>0">
                                <div class="joinedEntrants" [ngStyle]="{'width':getJoinedEntrantsWidth(league,'')}" *ngFor="let item of getJoinedEntrantsWidth(league,'length'); let i = index" [ngClass]="{'filled':i<league.league_joined_entrants}">
                                </div>
                            </div>
                            <div class="entrantsContainer" *ngIf="league.tournament_id==0">
                                <div class="joinedEntrants" [ngStyle]="{'width':getJoinedEntrantsWidth(league,'')}" *ngFor="let item of getJoinedEntrantsWidth(league,'length'); let i = index" [ngClass]="{'filled':i<league.joined_entrants}">
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </li>
            </div>
            <div class="filterBanner" *ngIf="filters.use == 'true'" (click)="disableFilters()">
                <div class="text">You are using custom filters. Click this banner to view all leagues.</div>
            </div>
        </ul>
        <ul class="leagueTableMobile" *ngIf="isMobile">
            <mat-progress-bar mode="buffer" *ngIf="!leagues.length && !emptyLobby"></mat-progress-bar>
            <div class="emptyLobby" *ngIf="emptyLobby">
                {{ (curGame=='all')?'No contests available right now.':'No '+curGameAbbr.toUpperCase()+' contests are available at this time. Please check again at a later time' }}
            </div>
            <li class="leagueEntryMobile ribbon-parent"
                (click)="openLeague(league.id,league.tournament_id,(league.draft_size - league.league_joined_entrants))"
                *ngFor="let league of leagues; trackBy: trackLeague;">
                <div class="ribbon" *ngIf="league.badge != null"
                    [ngStyle]="{'background-color':league.color_code,'font-size':'8px'}">{{league.badge}}</div>
                <div [ngClass]="{entry:true,user_joined:(league.league_member != null && league.league_member == user.id && (league.league_joined_entrants > 0 || league.tournament_id == 0)),league:(league.tournament_id == 0),tournament:(league.tournament_id > 0)}"
                    [ngStyle]="{'background-color':(league.updateStatus != null && league.updateStatus)?darkMode?'#ffffff08':'rgb(215, 225, 250)':null}">
                    <div class="lsContainer">
                        <div class="leagueSport"
                            [ngStyle]="{'backgroundImage':'url(\''+bucketURL+league.league_type.toLowerCase()+'_icon'+darkMode_ext+'.svg\')'}">
                        </div>
                    </div>
                    <div class="container">
                        <div class="top">
                            <div class="leagueName"
                                [ngStyle]="{'color':darkMode?'#eee':league.color_code,'font-weight':((league.lg_bold=='Y')?'bold':'normal')}">
                                {{league.name}}</div>
                        </div>
                        <div class="bottom">
                            <div class="leagueBuyin">${{league.buy_in_amount | number:'1.2-2' | Price}}</div>
                            <div class="leagueEntrants">
                                <span *ngIf="league.hide_entrant == undefined || league.hide_entrant == 'N'">{{league.joined_entrants+' of '+league.entrants}}</span>
                                <span *ngIf="league.hide_entrant !== undefined && league.hide_entrant == 'Y'">{{ league.joined_entrants }}</span>
                            </div>
                            <div class="leaguePrizes">Prizes: <span
                                    class="prizeAmt">${{league.payout_amount | number:'1.2-2' | Price}}</span></div>
                        </div>
                    </div>
                    <div class="lobby-footer" *ngIf="league.tournament_id > 0">
                        <div class="container">
                            <div class="left">
                                {{league.league_joined_users}}
                            </div>
                            <div class="middle">
                                <img *ngIf="league?.ticket_id>0" src="assets/images/ticket.png">
                            </div>
                            <div class="right">
                                {{league.kick_off}}
                            </div>
                        </div>
                    </div>
                    <!-- <div class="leagueType">{{league.draft_type}}</div> -->
                </div>
            </li>
            <div class="filterBanner" *ngIf="filters.use == 'true'" (click)="filters.use = 'false';loadLobby();">
                <div class="text">You are using custom filters. Click to view all leagues.</div>
            </div>
            <div class="mobileBottom"></div>
        </ul>
        <div class="bottomButton" *ngIf="showFilter"
            [ngStyle]="{'bottom':(filters.use == 'true')?((isMobile)?'85px':'65px'):((isMobile)?'55px':'20px')}">
            <a class="noDec" [href]="siteURL+'/create-contest'"><span class="addContest" matTooltip="Create A Contest"
                    matTooltipPosition="above"><i class="fas fa-plus"></i></span></a>
            <span class="filterLobby" (click)="openFilters()" matTooltip="Lobby Filters" matTooltipPosition="above"><i
                    class="fas fa-sliders-h"></i></span>
        </div>
        <div class="footer" *ngIf="leagues.length">Player news and projections provided by <a href="https://www.rotowire.com/" target="_blank">Rotowire.com </a><span *ngIf="version">(V- {{version}})</span></div>
    </div>
    <div class="rightSide" [ngClass]="{'sameHeight':!isMobile}">
        <app-newsfeed></app-newsfeed>
    </div>
</div>

<div *ngIf="showlobby==false" [ngClass]="{'macOS':isMac,'otherOS':!isMac}">
    <div id="miniLobbysidebar" class="nav-collapse miniLobbysidebar">
        <div class="ml-heading-title">
          Join A Draft
        </div>
        <div class="ml-content scrollTable">
          <ul class="">
            <mat-progress-bar mode="buffer" *ngIf="!leagues.length"></mat-progress-bar>
            <div class="emptyLobby" *ngIf="emptyLobby">
                {{ (curGame=='all')?'No contests available right now.':'No '+curGameAbbr.toUpperCase()+' contests are available at this time. Please check again at a later time' }}
            </div>
            <li class="miniLobbyLi ml-ribbon-parent"
                (click)="openLeague(league.id,league.tournament_id,(league.draft_size - league.league_joined_entrants))"
                *ngFor="let league of leagues; trackBy: trackLeague;">
                <div class="ml-ribbon" *ngIf="league.badge != null" [ngStyle]="{'background-color':league.color_code,'font-size':'8px'}">{{league.badge}}</div>
                <div [ngClass]="{mlentry:true,user_joined:(league.league_member != null && league.league_member == user.id && (league.league_joined_entrants > 0 || league.tournament_id == 0)),league:(league.tournament_id == 0),tournament:(league.tournament_id > 0)}"
                    [ngStyle]="{'background-color':(league.updateStatus != null && league.updateStatus)?darkMode?'#ffffff08':'rgb(215, 225, 250)':null}">                    
                    <div class="ml-container">
                        <div class="ml-top">
                          <div class="ml-lsContainer">
                              <div class="ml-leagueSport"
                              [ngStyle]="{'backgroundImage':'url(\''+bucketURL+league.league_type.toLowerCase()+'_icon'+darkMode_ext+'.svg\')'}">
                              </div>
                          </div>
                            <div class="ml-leagueName"
                                [ngStyle]="{'color':darkMode?'#eee':league.color_code,'font-weight':((league.lg_bold=='Y')?'bold':'normal')}">
                                &nbsp;{{league.name}}</div>
                        </div>
                        <div class="ml-bottom">
                            <div class="ml-leagueBuyin">${{league.buy_in_amount | number:'1.2-2' | Price}}</div>
                            <div class="ml-leagueEntrants">
                                <span *ngIf="league.hide_entrant == undefined || league.hide_entrant == 'N'">{{league.joined_entrants+' of '+league.entrants}}</span>
                                <span *ngIf="league.hide_entrant !== undefined && league.hide_entrant == 'Y'">{{ league.joined_entrants }}</span>
                            </div>
                            <div class="ml-leaguePrizes">Prizes: <span
                                    class="ml-prizeAmt">${{league.payout_amount | number:'1.2-2' | Price}}</span></div>
                        </div>
                    </div>
                    <div class="ml-footer" *ngIf="league.tournament_id > 0">
                        <div class="ml-container">
                            <div class="ml-left">
                                {{league.league_joined_users}}
                            </div>
                            <div class="ml-right">
                                {{league.kick_off}}
                            </div>
                        </div>
                    </div>
                    <!-- <div class="leagueType">{{league.draft_type}}</div> -->
                </div>
            </li>
            
        </ul>
        </div>
      </div>
</div>